<template>
    <div class="alert" v-prevent-overscroll>
        <div class="alert-area">
            <div class="success-wrapper" :style="baseStyle">
                <div class="success-content">
                    <img class="card-img" :style="figureStyle" :src="info.$$opts.cardImage" />
                </div>
                <div class="collect-btn" :style="collectStyle" @click.stop="closeSuccess"></div>
                <div class="share-btn" :style="shareStyle" @click.stop="shareCard"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    name: 'collectCardSuccess',

    props: {
        info: { // 收集卡片成功
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },
    },

    data() {

        return {

            baseStyle: { // 基本样式

            },

            figureStyle: { // 人物卡片样式

			},

            collectStyle: { // 集卡样式

            },

            shareStyle: { // 分享样式

            }

        }

    },

    mounted() {

        this.initStyle(this.info)

    },

    methods: {

        initStyle(val) {
    
            let { base, figure, collect, share } = val

            let transform = (config, imgKey) => {

				let options = {}

				if (config.width) {
					options.width = `${config.width}px`
				}

				if (config.height) {
					options.height = `${config.height}px`
				}

				if (config.position1 && config.position1.type) {
					options[`${config.position1.type}`] =  `${config.position1.value || 0}px`
				}

				if (config.position2 && config.position2.type) {
					options[`${config.position2.type}`] =  `${config.position2.value || 0}px`
				}

				if (imgKey) {
					if (config[imgKey] && config[imgKey].url) {
						let background = {
							backgroundImage: `url(${config[imgKey].url})`,
							backgroundSize: `100% 100%`,
							backgroundPosition: '0px 0px',
						}
						options= Object.assign(options, background)
					}
				}

				return options

			}

            this.baseStyle   = base && transform(base, 'img') || {}
			this.collectStyle  = collect && transform(collect, 'img') || {}
			this.figureStyle = figure && transform(figure, 'background') || {}
			this.shareStyle  = share && transform(share, 'img') || {}


        },

        closeSuccess() { // 关闭集卡成功
            this.$emit('emitEvent', {
				type: 'closeCollectCardSuccess',
				data: null,
				options: null
			})
        },

        shareCard() { // 分享卡片
            this.$emit('emitEvent', {
				type: 'shareCollectSuccessCard',
				data: this.info,
				options: null
			})
			this.$emit('emitEvent', {
				type: 'closeCollectCardSuccess',
				data: null,
				options: null
			})
        },     

    },


}

</script>

<style lang="scss" scoped>

.alert {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.success-wrapper {
    position: relative;
    .success-content {
        position: absolute;
		z-index: 1;
    }
    .card-img {
        width: 100%;
		height: 100%;
    }
    .collect-btn {
        z-index: 2;
		position: absolute;
    }
    .share-btn {
        z-index: 2;
		position: absolute;
    }
}



</style>